export const SSO_INTEGRATIONS_STATES = {
    SSO_INTEGRATION_LOADING: "SSO_INTEGRATION_LOADING",
    SSO_INTEGRATION_READY: "SSO_INTEGRATION_READY",
}

export const SSO_INTEGRATIONS_STATES_MESSAGE_MAP = {
    [SSO_INTEGRATIONS_STATES.SSO_INTEGRATION_LOADING]: "",
}

export const SSO_INTEGRATION_QUERY_PARAM = 'sso_integration';